import { useAppSelector } from '../..'
import { type ISurveyTemplateListResponse } from '../../../models/SurveyTemplate'

export const surveyListDetails = (): ISurveyTemplateListResponse => useAppSelector((state) => state.survey?.surveyList)
export const isSurveyListLoading = (): boolean => useAppSelector((state) => state.survey.surveyListLoading)
export const deleteLoading = (): boolean => useAppSelector((state) => state.survey.deleteLoading)
export const archiveLoading = (): boolean => useAppSelector((state) => state.survey.archiveLoading)
export const loading = (): boolean => useAppSelector((state) => state.survey.loading)
